import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid } from '../utils/Validator';
import "./Form.css";

const { Item: ItemForm } = Form;

export default class MarcaForm extends Component {
  state = {
    registro: {
      mar_idf: '',
      mar_descricao: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        this.refs.mar_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.mar_descricao) || (this.state.registro.mar_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }

    this.props.onSalvarClick(this.state.registro);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { mar_idf, mar_descricao } = this.state.registro;

    return (
      <Modal
        title={mar_idf ? "Edição de Marca" : "Cadastro de Marca"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={24}>
              <span>Descrição</span>
              <InputForm
                id="mar_descricao"
                ref="mar_descricao"
                maxLength={30}
                onChange={this.onChange}
                value={mar_descricao}
                validator={value => Boolean(value)}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MarcaForm.js